// Zeitraum-Helper für die Vertriebler-Auswertung.
//
// Liefert für jede Vorgabe ein {start, ende} Paar im YYYY-MM-DD-Format
// (passend für ein <input type="date"> und für PB-Date-Filter).

function pad(n) {
  return String(n).padStart(2, '0');
}

function toIsoDate(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function endOfDay(d) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}

/** Diese Woche, Montag bis Sonntag (lokale Zeitzone). */
function dieseWoche() {
  const heute = new Date();
  const dow = (heute.getDay() + 6) % 7; // Montag = 0
  const montag = startOfDay(new Date(heute));
  montag.setDate(heute.getDate() - dow);
  const sonntag = endOfDay(new Date(montag));
  sonntag.setDate(montag.getDate() + 6);
  return { start: toIsoDate(montag), ende: toIsoDate(sonntag) };
}

/** Aktueller Kalendermonat. */
function dieserMonat() {
  const heute = new Date();
  const start = new Date(heute.getFullYear(), heute.getMonth(), 1);
  const ende = new Date(heute.getFullYear(), heute.getMonth() + 1, 0);
  return { start: toIsoDate(start), ende: toIsoDate(ende) };
}

/** Vorheriger Kalendermonat. */
function letzterMonat() {
  const heute = new Date();
  const start = new Date(heute.getFullYear(), heute.getMonth() - 1, 1);
  const ende = new Date(heute.getFullYear(), heute.getMonth(), 0);
  return { start: toIsoDate(start), ende: toIsoDate(ende) };
}

/** Aktuelles Quartal. */
function aktuellesQuartal() {
  const heute = new Date();
  const quartal = Math.floor(heute.getMonth() / 3);
  const start = new Date(heute.getFullYear(), quartal * 3, 1);
  const ende = new Date(heute.getFullYear(), quartal * 3 + 3, 0);
  return { start: toIsoDate(start), ende: toIsoDate(ende) };
}

export const ZEITRAUM_OPTIONS = [
  { value: 'woche', label: 'Diese Woche' },
  { value: 'monat', label: 'Dieser Monat' },
  { value: 'letzter_monat', label: 'Letzter Monat' },
  { value: 'quartal', label: 'Aktuelles Quartal' },
  { value: 'individuell', label: 'Individuell' },
];

export function bereichFuer(option) {
  switch (option) {
    case 'woche':
      return dieseWoche();
    case 'monat':
      return dieserMonat();
    case 'letzter_monat':
      return letzterMonat();
    case 'quartal':
      return aktuellesQuartal();
    case 'individuell':
    default:
      return null;
  }
}

/**
 * Wandelt ein YYYY-MM-DD Date in einen PB-Filter-tauglichen Datums-String um.
 * Für "Start" verwenden wir 00:00:00, für "Ende" 23:59:59 — damit Records
 * vom Endtag noch im Bereich liegen.
 */
export function toPbStart(isoDate) {
  return `${isoDate} 00:00:00`;
}
export function toPbEnde(isoDate) {
  return `${isoDate} 23:59:59`;
}
